import { Link } from "react-router-dom"

const HostnameLink = ({ record, children, isAdmin = true }) => {
  const label = children || record?.hostname || "—"
  const id = record?._id || record?.deviceId
  if (!isAdmin || !id) {
    return <span>{label}</span>
  }

  return (
    <Link className="hostname-link" to={`/device-management/${id}`}>
      {label}
    </Link>
  )
}

export default HostnameLink
